export default __webpack_public_path__ + "static/media/bg-top.99d18ad4.svg";